import { render, staticRenderFns } from "./MessagingScene.vue?vue&type=template&id=3a4e2cc8"
import script from "./MessagingScene.vue?vue&type=script&lang=ts"
export * from "./MessagingScene.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports